import { forwardBannerClickToAnalytics } from './forwardBannerClickToAnalytics';

export interface BannerClickEventDetail {
  event: 'banner_click';
  analytics_tag: string;
  banner_id: string;
  banner_key?: string;
}

export interface TrackBannerClickParams {
  analytics_tag?: string;
  banner_id: string;
  banner_key?: string;
}

function isDevBuild(): boolean {
  return typeof import.meta !== 'undefined' && Boolean(import.meta.env?.DEV);
}

export function trackBannerClick(params: TrackBannerClickParams): void {
  const analyticsTag = params.analytics_tag?.trim();
  if (!analyticsTag) return;

  const detail: BannerClickEventDetail = {
    event: 'banner_click',
    analytics_tag: analyticsTag,
    banner_id: params.banner_id,
    ...(params.banner_key ? { banner_key: params.banner_key } : {}),
  };

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('banner_click', { detail }));
  }

  forwardBannerClickToAnalytics(detail);

  if (isDevBuild()) {
    console.debug('[banner_click]', detail);
  }
}
